import { addHelpIconTooltip, reformatLabelForId } from 'modules/placements/utils';
import { H4 } from 'ui/theme';
import {
  ActionButtonToggles,
  RawDataInput,
  ToggleFormField,
  ToggleFormFieldProps,
} from './components';
import { CustomTextFields } from './components/CustomTextFields';
import { ContentBlock, Section, StyledSectionTitle, StyledFormField } from './styles';

export const CONTENT = {
  actionButtonsFieldLabel: 'Action buttons',
  behaviorSectionTitle: 'Behavior',
  bodyFieldLabel: 'Body',
  contentSectionTitle: 'Content',
  customTextFieldsSectionTitle: 'Custom text fields',
  dataFeedsFieldHelpText: 'External URLs to query for dynamic data.',
  dataFeedsFieldLabel: 'Data feeds',
  detailsBlockHeader: 'Details',
  detailsBlockHeaderTooltipContent: 'Define the content fields associated with this placement.',
  mediaUrlFieldHelpText: 'Link to an image or video.',
  mediaUrlFieldLabel: 'Media URL',
  openActionFieldHelpText:
    'When enabled, a click or tap anywhere in the message opens a specified URL or does a custom action.',
  openActionFieldLabel: 'Open action',
  rawDataFieldLabel: 'Raw data (JSON)',
  textFieldsFieldLabel: 'Text fields',
  textFieldsFieldTooltipContent:
    'Additional text fields to include in this placement, for custom content.',
  titleFieldLabel: 'Title',
};

export const detailsContent: ToggleFormFieldProps[] = [
  {
    name: 'hasTitle',
    labelText: CONTENT.titleFieldLabel,
  },
  {
    name: 'hasBody',
    labelText: CONTENT.bodyFieldLabel,
  },
  {
    name: 'hasMedia',
    helpText: CONTENT.mediaUrlFieldHelpText,
    labelText: CONTENT.mediaUrlFieldLabel,
  },
  {
    name: 'hasDataFeeds',
    helpText: CONTENT.dataFeedsFieldHelpText,
    labelText: CONTENT.dataFeedsFieldLabel,
  },
];

export const DetailsContentBlock = () => {
  return (
    <ContentBlock data-test="details-content">
      <H4>
        {addHelpIconTooltip(CONTENT.detailsBlockHeader, CONTENT.detailsBlockHeaderTooltipContent)}
      </H4>

      <Section>
        <StyledSectionTitle>{CONTENT.contentSectionTitle}</StyledSectionTitle>
        {detailsContent.map(({ name, helpText, labelText }) => (
          <ToggleFormField
            key={`toggle-form-field-${reformatLabelForId(labelText)}`}
            name={name}
            helpText={helpText}
            labelText={labelText}
          />
        ))}
      </Section>

      <Section>
        <StyledSectionTitle>{CONTENT.customTextFieldsSectionTitle}</StyledSectionTitle>
        <StyledFormField
          labelText={addHelpIconTooltip(
            CONTENT.textFieldsFieldLabel,
            CONTENT.textFieldsFieldTooltipContent,
          )}
          isHorizontalLayout
        >
          <CustomTextFields />
        </StyledFormField>
      </Section>

      <Section>
        <StyledSectionTitle>{CONTENT.behaviorSectionTitle}</StyledSectionTitle>
        <ToggleFormField
          name="hasOpenAction"
          helpText={CONTENT.openActionFieldHelpText}
          labelText={CONTENT.openActionFieldLabel}
        />
        <StyledFormField labelText={CONTENT.actionButtonsFieldLabel} isHorizontalLayout>
          <ActionButtonToggles />
        </StyledFormField>
        <StyledFormField labelText={CONTENT.rawDataFieldLabel} isHorizontalLayout>
          <RawDataInput />
        </StyledFormField>
      </Section>
    </ContentBlock>
  );
};
